module.exports = __webpack_public_path__ + "img/panneau_mobile2.f6896062.jpg";